import React from 'react'

import PlaceService from '../services/PlaceService';

export default class AutoCompleteAddressResults extends React.Component {

    constructor(props) {
        super(props);
        this.handleResultClick = this.handleResultClick.bind(this);
    }

    getPlaceService() {
        if (!this.placeService) {
            this.placeService = new PlaceService("maps-attributions")
        }
        return this.placeService;
    }

    handleResultClick(placeId) {
      this.getPlaceService().getPlace(this.props.token, placeId, (placeResult) => {
          this.props.onAddressClicked(placeResult);
      });
    }

    renderResults() {
        return <div>
            {
                this.props.addresses.map((address, index) => {
                    return <div key={`address-${index}`}
                                style={styles.address}
                                onClick={() => this.handleResultClick(address.placeId)}>{address.description}</div>
                })
            }
        </div>
    }

    render() {
        return (
            <div>
                <div>{this.renderResults()}</div>
                <div id="maps-attributions" style={styles.poweredByGoogle}>Powered by Google</div>
            </div>
        )
    }
}

const styles = {
    address: {
        margin: '10px',
        padding: '10px 0',
        borderBottom: '1px solid lightgray',
        cursor: 'pointer',
        fontSize: '16px'
    },
    poweredByGoogle: {
        textAlign: 'center',
        fontWeight: '400',
        margin: '20px'
    }
};